import React, { useState } from "react";
import { applyCoupon } from "../api/purchase";

const CouponComponent = ({ setDiscount, cart, message, setMessage }) => {
  const [couponCode, setCouponCode] = useState("");

  // Function to handle coupon validation
  async function apply() {
    console.log("Applying coupon...");
    console.log(cart);
    const response = await applyCoupon(couponCode, cart);
    console.log(response);

    setDiscount(response);
    setMessage(response.message);
  };

  return (
    <div>
      <input
        type="text"
        value={couponCode}
        onChange={(e) => setCouponCode(e.target.value)}
        placeholder="Enter coupon code"
      />
      <button onClick={() => apply()}>
        Apply
      </button>
      <p>{message}</p>
    </div>
  );
};

export default CouponComponent